import { gql } from '@apollo/client';

const devicesQuery = gql`
  {
    pages(first: 500) {
      nodes {
        uri
        slug
      }
    }
  }
`;

export default devicesQuery;
